import { useState, useEffect } from "react";
import { useAccount } from "@hooks/useAccount";
import { AccountPageLayout } from "../AccountPageLayout";
import { Loading } from "../Loading";
import { Error } from "../Error";
import { BasicInfo } from "./BasicInfo";
import { Notifications } from "./Notifications";
import { ShoppingPrefs } from "./ShoppingPrefs";
import styles from "./styles/Preferences.module.css";

export const Preferences = () => {
  const [success, setSuccess] = useState(false);
  const { account, isLoading } = useAccount();
  const { error } = account;

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [success]);

  if (error) {
    return (
      <Error
        title="Preferences"
        errorMessage={error.message}
      />
    )
  };

  if (isLoading) {
    return <Loading title="Preferences" />
  };

  const Section = ({ title, children }) => {
    return (
      <section className={styles.section}>
        <h2 className={styles.title}>{title}</h2>
        {children}
      </section>
    )
  }

  return (
    <AccountPageLayout title="Preferences">
      <section className={styles.container}>
        <Section title="Basic Information">
          <BasicInfo account={account} setSuccess={setSuccess} />
        </Section>
        <Section title="Notification Preferences">
          <Notifications account={account} setSuccess={setSuccess} />
        </Section>
        <Section title="Shopping Preferences">
          <ShoppingPrefs account={account} setSuccess={setSuccess} />
        </Section>
        {success && (
          <p className={styles.success}>
            Success. Your changes have been saved.
          </p>
        )}
      </section>
    </AccountPageLayout>
  )
}
